/* Copyright (c) 2022 MOCA Systems, Inc.  All rights reserved. */

export enum ReportType {
	ConstraintLog = 'constraintLog',
	DraftTickets = 'onDeckTickets',
	ExportToCSV = 'exportToCSV',
	GanttChart = 'ganttView',
	OverdueActivity = 'overdueActivity',
	PPCReport = 'ppcReport',
	SixWeekLookAhead = 'sixWeekLookAhead',
	BasicVarianceReason = 'varianceReason',
	AdvancedVarianceReason = 'varianceReview',
	WeeklyWorkPlan = 'weeklyWorkPlan',
	ExportTickets = 'exportTickets',
}
